export enum EntityType {
  ASSIGNMENT,
  TEACHING_PATH
}

export enum Locales {
  EN = 'en',
  NB = 'nb',
  NN = 'nn',
  FN = 'fi',
  KV = 'kv',
  SU = 'su',
  RU = 'ru',
  UK = 'uk'
}

/**
 * A string read from storage or a URL is a `string`, and comparing one with a string enum member
 * is what `no-unsafe-enum-comparison` flags: nothing says it is one of the members. These say so.
 */
export const isLocale = (value: string | null | undefined): value is Locales =>
  typeof value === 'string' && (Object.values(Locales) as Array<string>).includes(value);

export enum BooleanFilter {
  TRUE = 'true',
  FALSE = 'false'
}

/** A `<select>` value is a `string`; this says whether it is one of the two members. */
export const isBooleanFilter = (value: string): value is BooleanFilter =>
  (Object.values(BooleanFilter) as Array<string>).includes(value);

export enum ActivityFilter {
  INACTIVE,
  ACTIVE,
  ALL
}

export enum SortingFilter {
  ASC = 'asc',
  DESC = 'desc',

  DEADLINE = 'deadline',
  CREATION_DATE = 'creationDate'
}

export enum ArticleLevels {
  FIRST_LEVEL = 'niva-1',
  SECOND_LEVEL = 'niva-2',
  THIRD_LEVEL = 'niva-3'
}

export enum EditEntityLocaleKeys {
  NEW_ASSIGNMENT = 'new assignment',
  EDIT_TEACHING_PATH = 'edit_teaching_path'
}

export enum StoreState {
  PENDING,
  LOADING,
  ERROR,
}

export enum SliderButtonBehavior {
  CURRENT_TAB = 'self_window',
  NEW_TAB = 'new_window',
  POPUP = 'popup_window',
}

export enum QueryStringKeys {
  LOCALE = 'locale',
  GRADE = 'grade',
  SUBJECT = 'subject',
  ORDER = 'order',
  ORDER_FIELD = 'orderField',
  SEARCH = 'search',
  PAGE = 'page',
  ACTIVITY = 'activity',
  IS_ANSWERED = 'isAnswered',
  IS_EVALUATED = 'isEvaluated',
  GREPCOREELEMENTSIDS = 'grepCoreElementsIds',
  GREPMAINTOPICSIDS = 'grepMainTopicsIds',
  GREEPGOALSIDS = 'grepGoalsIds',
  GREPREADINGINSUBJECT = 'grepReadingInSubject',
  SOURCE = 'source',
  MYSCHOOL = 'onlyOwnSchools',
  ARTICLES = 'articles',
}

export enum QueryStringKeysSearch {
  LANG = 'lang',
  GRADE = 'grade',
  SUBJECT = 'subject',
  SEARCH = 'search',
  PAGE = 'page',
  ACTIVITY = 'activity',
  GREPCOREELEMENTSIDS = 'grepCoreElementsIds',
  GREPMAINTOPICSIDS = 'grepMainTopicsIds',
  GREEPGOALSIDS = 'grepGoalsIds',
  GREPREADINGINSUBJECT = 'grepReadingInSubject',
  SOURCE = 'source',
  MYSCHOOL = 'onlyOwnSchools',
  ARTICLES = 'articles',
}

export enum ReturnUrl {
  RETURN_URL = 'return_url',
  TIME_EXPIRED = 'return_url_expired'
}
